import { render } from "./ShukkaDetailPage.vue?vue&type=template&id=0a19a4ae"
import script from "./ShukkaDetailPage.vue?vue&type=script&lang=js"
export * from "./ShukkaDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\eguchi\\Desktop\\git\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__